import React, { useState, useEffect, useRef, useContext } from "react";
import { Spinner } from "../../../components/Spinner";
import { showApiErrors } from "../../../utils/showApiErrors";
import {
  TimePicker,
  Modal,
  message,
  Popover,
  Button,
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Select,
  Upload,
} from "antd";

import { PlusCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import styles from "../../styles/Registers.module.css";
import { AddOrEditPatient } from "../../patitents/components/AddOrEditPatient";
import { AddOrEditReportType } from "../../report-types/components/AddOrEditReportType";

import {
  getSelectOptionsWithOrWithoutImg,
  getSelectPatientOptions,
  getSelectReportTypeOptions,
  getSelectDoctorOptions,
} from "../../../utils/options";
import { UserContext } from "../../../contexts/userContext";
import { OrdinationsAndCountriesContext } from "../../../contexts/ordinationsAndCountriesContext";
import { patientsService } from "../../../services/patients";
import { reportTypesService } from "../../../services/reportTypes";
import { doctorsService } from "../../../services/doctorService";

import { medicalReportsService } from "../../../services/medicalReports";
import { AutoComplete } from "./AutoComplete";
import { TimePickerRange } from "./TimePickerRange";

import {
  openErrorNotification,
  openSuccessNotification,
  openWarningNotification,
} from "../../../utils/notifications";
import { useNavigate, useParams } from "react-router";

const dateFormat = "DD/MM/YYYY";
const { TextArea } = Input;

const UZ_HOST = "https://localhost:8198";

export const AddOrEditMedicalReport = () => {
	const navigate = useNavigate()

	const { id: reportId } = useParams()

  const { userInfo } = useContext(UserContext);
  const { countries } = useContext(OrdinationsAndCountriesContext);
  const [patients, setPatients] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [diagnoses, setDiagnoses] = useState([]);
  const [visiblePatientModal, setVisiblePatientModal] = useState(false);
  const [visibleReportTypeModal, setVisibleReportTypeModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const [medicalReportId, setMedicalReportId] = useState(false);
  const [defaultUltrasoundImages, setDefaultUltrasoundImages] = useState([]);
  const [reportTimeRange, setReportTimeRange] = useState([]);
  const [IsForSending, setIsForSending] = useState(false);
  const [selectedMedicalReport, setSelectedMedicalReport] = useState({});
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [disabledDates, setDisabledDates] = useState([]);

  const [ucnValue, setUcnValue] = useState("");
  const [csnValue, setCsnValue] = useState("");
  const [psnValue, setPsnValue] = useState("");
  const [birthDateValue, setBirthDateValue] = useState("00-00-00");
  const [phoneNumberValue, setPhoneNunmberValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [addressValue, setAddressValue] = useState("");
  const [specializationValue, setSpecializationValue] = useState("");
  const [priceValue, setPriceValue] = useState("");

  const [medical_record, setMedicalRecord] = useState("");
  const [anamnesis, setAnamnesis] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [therapy, setTherapy] = useState("");

	const [buttonUZLoading, setButtonUZLoading] = useState(false);

  const [autocompleteValues, setAutocompleteValues] = useState({
    code: "",
    name: "",
    latin_name: "",
  });

  const [initialCustomerPib, setInitialCustomerPib] = useState();
  const [enableEdit, setEnableEdit] = useState(!reportId);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const role = localStorage.getItem("role");

  const [isUZAccessible, setIsUZAccessible] = useState(false);

  const [form] = Form.useForm();

  if (reportTimeRange[0] && reportTimeRange[1]) {
    form.setFieldsValue({
      report_date_time_range: [reportTimeRange[0], reportTimeRange[1]],
    });
  } else {
    form.setFieldsValue({
      report_date_time_range: null,
    });
  }
  if (userInfo.doctor) {
    form.setFieldsValue({
      doctor: userInfo.doctor.first_name + " " + userInfo.doctor.last_name,
    });
  }
  const ref = useRef(null);
  useEffect(() => {
    if (Number(reportId)) {
      fetchMedicalReportDetails(reportId);
    }
  }, [reportId, form]);

  const setPatientDetails = (patient) => {
    setUcnValue(patient.ucn);
    setPsnValue(patient.psn);
    setCsnValue(patient.csn);
    setBirthDateValue(
      patient.birth_date
        ? String(patient.birth_date).split("-").reverse().join("/")
        : "",
    );
    setPhoneNunmberValue(patient.phone_number);
    setEmailValue(patient.email);
    setCityValue(patient.city);
    setAddressValue(patient.address);
  };
  const setReportTypeDetails = (report_type) => {
    setSpecializationValue(report_type.specialization.name);
    setPriceValue(report_type.price);
  };
  const fetchMedicalReportDetails = async (id) => {
    setLoading(true);
    try {
      const res = await medicalReportsService.getMedicalReportInfo(id);

      const {
        patient,
        report_type,
        medical_record,
        anamnesis,
        diagnosis,
        therapy,
        images,
        doctor,
        date_end,
        date_start,
      } = res;

      if (!res) {
        setIsClosed(true);
        //setIsForSending(receipt || pre_receipt);
      }

      setMedicalRecord(medical_record);
      setAnamnesis(anamnesis);
      setDiagnosis(diagnosis);
      setTherapy(therapy);
      setSelectedMedicalReport(res);
      let imagesarr = images.map((elem) => {
        return { uid: elem.id, url: elem.image };
      });
      setSelectedImages(imagesarr);
      setMedicalReportId(id);
      setPatientDetails(patient);

      setReportTypeDetails(report_type);

      //let report_date= date_start.split("T")[0].split('-')

      //console.log(report_date[2]+'/'+report_date[1]+'/'+report_date[0])
      let report_date = date_start ? new Date(date_start) : "";
      let report_date_end = date_end ? new Date(date_end) : "";
      form.setFieldsValue({
        report_type: report_type.id,
        patient: patient.id,
        medical_record,
        anamnesis,
        diagnosis,
        therapy,
        doctor: doctor.id,
        report_date: report_date ? dayjs(report_date) : null,
        report_date_time_range: report_date_end
          ? [dayjs(report_date, "HH:mm"), dayjs(report_date_end, "HH:mm")]
          : null,
      });
      if (report_date_end) {
        setReportTimeRange([
					dayjs(report_date).format("HH:mm"),
					dayjs(report_date_end).format("HH:mm"),
        ]);
			}
      getDoctors(report_type.specialization.id);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const transformData = async (fromForm) => {
    const { patient, report_type } = fromForm;

    let dataForPost = {
      patient,
      report_type,
      medical_record: medical_record,
      anamnesis: anamnesis,
      diagnosis: diagnosis,
      therapy: therapy,
      doctor: userInfo.doctor ? userInfo.doctor.id : fromForm.doctor,
      images: [...selectedImages],
      date_start: fromForm.report_date
        ? String(fromForm.report_date.format("YYYY-MM-DDT")) +
					reportTimeRange[0]
        : null,
      date_end: fromForm.report_date
        ? String(fromForm.report_date.format("YYYY-MM-DDT")) +
          reportTimeRange[1]
        : null,
    };

    if (medicalReportId) {
      dataForPost = { ...dataForPost };
    }
    return dataForPost;
  };
  const confirmCancelMedicalReportForm = () => {
    Modal.confirm({
      maskClosable: true,
      title:
        "Da li ste sigurni da želite da odustanete, izmjene neće biti sačuvane?",
      okText: "Da",
      okType: "danger",
      cancelText: "Ne",
      onOk: () => {
        navigate("/");
      },
    });
  };

  const saveMedicalReport = async () => {
    form.submit();
  };

  const checkUZAccess = async () => {
    try {
      const response = await fetch(UZ_HOST);

      const data = await response.json();

      if (data?.status === "active") {
        setIsUZAccessible(true);
      }
    } catch (e) {}
  };

  const onSubmit = async (values) => {
    setButtonLoading(true);

    const data = await transformData(values);
    let res;
    try {
      res = medicalReportId
        ? await medicalReportsService.editMedicalReports(medicalReportId, data)
        : await medicalReportsService.addReport(data);
      // TODO redirect on add
      if (res) {
        openSuccessNotification({ message: "Uspješno sačuvano!" });
        navigate("/");
        setEnableEdit(false);
      } else {
        openErrorNotification({ message: "Neuspješno dodavanje!" });
      }
    } catch (e) {
      showApiErrors(e);
    } finally {
      if (res && res.id && !medicalReportId) {
        //navigate("/medical-reports/edit/" + res.id);
      } else {
        //await fetchInvoiceDetails(reportId);
        setButtonLoading(false);
      }
    }
  };
  async function getPatients() {
    setLoading(true);
    try {
      const { results } = await patientsService.getAllPatients();
      setPatients(results);
      return results[0];
    } catch (e) {
      showApiErrors(e);
    } finally {
      setLoading(false);
    }
  }
  async function getReportTypes() {
    setLoading(true);
    try {
      const { results } = await reportTypesService.getAllReportTypes();
      setReportTypes(results);
      return results[0];
    } catch (e) {
      showApiErrors(e);
    } finally {
      setLoading(false);
    }
  }
  async function getDoctors(specialization) {
    try {
      const { results } = await doctorsService.getAllDoctors(specialization);
      setDoctors(results);
      return results[0];
    } catch (e) {
      showApiErrors(e);
    } finally {
    }
  }

  async function getUnavailableDates(value) {
    try {
      let date = value.format("DD-MM-YYYY");
      let id = 0;
      if (userInfo.type == "D") id = userInfo.id;
      const { results } = await doctorsService.getUnavailableTimes(date, id);
      setDisabledDates(results);
      //let mom = dayjs(results[0].date_start.split('T')[1].split('+')[0],'HH:mm')
    } catch (e) {
      console.log(e);
      showApiErrors(e);
    } finally {
    }
  }
  useEffect(() => {
    getPatients();
    getReportTypes();
    checkUZAccess();
  }, []);
  /*async function getDiagnoses(searchValue) {
    setLoading(true);
    try {
      const { results } = await diagnosesService.getAllDiagnoses(searchValue);
      setDiagnoses(results);
    } catch (e) {
      showApiErrors(e);
    } finally {
      setLoading(false);
    }
  }*/
  const onChangeDiagnosisValue = (name, value) => {
    // if (value.length == 2) getDiagnoses(value);
    setDiagnosis(value);
  };

  const autoCompleteUpdate = (data) => {
    const { code, name, latin_name } = data;
    setAutocompleteValues({
      code,
      name,
      latin_name,
    });
  };
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const handleImageRemove = (file) => {
    let newSelectedImages = selectedImages.filter(
      (oneitem) => oneitem !== file,
    );
    setSelectedImages(newSelectedImages);
  };
  const handleImageChange = ({ fileList }) => {
    setSelectedImages([...fileList]);
  };

  const handlePatientChange = (value) => {
    const patient = patients.find((x) => x.id == value);
    setUcnValue(patient.ucn);
    setPsnValue(patient.psn);
    setCsnValue(patient.csn);
    setBirthDateValue(
      patient.birth_date
        ? String(patient.birth_date).split("-").reverse().join("/")
        : "",
    );
    setPhoneNunmberValue(patient.phone_number);
    setEmailValue(patient.email);
    setCityValue(patient.city);
    setAddressValue(patient.address);
  };
  const handleReportTypeChange = async (value) => {
    const reportType = reportTypes.find((x) => x.id == value);
    setSpecializationValue(reportType.specialization.name);
    setPriceValue(reportType.price);

		let specializationId = reportType?.specialization?.id

		if (!specializationId && typeof reportType?.specialization === "number") {
			specializationId = reportType.specialization
		}

    await getDoctors(specializationId);
  };

  const fetchImageFromUZ = async () => {
    console.log("Fetching...");
		setButtonUZLoading(true)

    try {
      const response = await fetch(`${UZ_HOST}/screenshot`);

      if (!response.ok) {
        console.warn("Non-200 response from UZ:", response.status);

        return;
      }

      const blob = await response.blob();

      const file = new File([blob], "fetched-image.jpg", { type: blob.type });

      const uploadFile = {
        uid: String(Date.now()),
        name: file.name,
        status: "done",
        url: URL.createObjectURL(file),
        originFileObj: file,
      };

      // Append to selected images
      setSelectedImages((prev) => [...prev, uploadFile]);
    } catch (error) {
      console.error("Failed to fetch image:", error);
    } finally {
			setButtonUZLoading(false)
		}
  };

  return loading ? (
    <Spinner></Spinner>
  ) : (
    <>
      <Form
        form={form}
        onFinish={onSubmit}
        style={{ backgroundColor: "#f7f8f9" }}
        onFinishFailed={({ errorFields }) => {
          form.scrollToField(errorFields[0].name);
        }}
        initialValues={{}}
      >
        <h1>
          {enableEdit & (role == "D")
            ? "Novi izvještaj"
            : !enableEdit & (role == "D")
              ? `Izmjena izvještaja broj ${reportId}`
              : enableEdit & (role == "N")
                ? "Zakazivanje pregleda"
                : "Izmjena zakazanog pregleda"}
        </h1>
        <Row gutter={[40, 0]} style={{ justifyContent: "space-around" }}>
          <Col xs={22} sm={11} className={styles.medicalReportFormBoxes}>
            <h3 className={styles.invoiceHeader}>Pacijent</h3>
            <h4 className={styles.invoiceSubHeader}>Odaberite pacijenta</h4>

            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>
                  <b>Pacijent:</b>
                </span>
              </Col>
              <Col xs={14} sm={12} className={styles.inputAntdRow}>
                <Form.Item
                  className={styles.formItem}
                  name="patient"
                  rules={[
                    {
                      required: true,
                      message: "Odaberite pacijenta!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    //style={{ width: 200 }}
                    optionFilterProp="data-searchvalue"
                    placeholder="Izaberite pacijenta"
                    notFoundContent={"Nema rezultata"}
                    //onChange={(e) => handlePatientChange(e.target.value)}
                    onChange={handlePatientChange}
                  >
                    {getSelectPatientOptions(patients || [])}
                  </Select>
                </Form.Item>
              </Col>
              <Popover content="Dodaj pacijenta" trigger="hover">
                <div>
                  <Button
                    onClick={() => {
                      setVisiblePatientModal(true);
                    }}
                  >
                    <PlusCircleOutlined />
                  </Button>
                </div>
              </Popover>
            </Row>
            <Row className={styles.formTwoSetFields} justify="baseline">
              <Col xs={10} sm={8}>
                <span>JMBG:</span>
              </Col>
              <Col xs={12} sm={12} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  value={ucnValue}
                  readOnly
                />
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Broj lične karte:</span>
              </Col>
              <Col xs={12} sm={12} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  value={csnValue}
                  readOnly
                />
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Broj pasoša:</span>
              </Col>
              <Col xs={12} sm={12} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  value={psnValue}
                  readOnly
                />
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Datum rođenja</span>
              </Col>
              <Col xs={12} sm={12} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  value={birthDateValue}
                  readOnly
                />
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Grad:</span>
              </Col>
              <Col xs={12} sm={12} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  value={cityValue}
                  readOnly
                />
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Adresa:</span>
              </Col>
              <Col xs={12} sm={12} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  value={addressValue}
                  readOnly
                />
              </Col>
            </Row>
          </Col>
          <Col xs={22} sm={11} className={styles.medicalReportFormBoxes}>
            <h3 className={styles.invoiceHeader}>Pregled</h3>
            <h4 className={styles.invoiceSubHeader}>Odaberite pregled</h4>

            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>
                  <b>Pregled i usluge:</b>
                </span>
              </Col>
              <Col xs={12} sm={11} className={styles.inputAntdRow}>
                <Form.Item
                  className={styles.formItem}
                  name="report_type"
                  rules={[
                    {
                      required: true,
                      message: "Izaberite pregled!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    //style={{ width: 200 }}
                    optionFilterProp="data-searchvalue"
                    placeholder="Izaberite pregled"
                    notFoundContent={"Nema rezultata"}
                    onChange={handleReportTypeChange}
                  >
                    {getSelectReportTypeOptions(reportTypes || [])}
                  </Select>
                </Form.Item>
              </Col>

              <Popover content="Dodaj pregled" trigger="hover">
                <div>
                  <Button
                    onClick={() => {
                      setVisibleReportTypeModal(true);
                    }}
                  >
                    <PlusCircleOutlined />
                  </Button>
                </div>
              </Popover>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Cijena:</span>
              </Col>
              <Col xs={12} sm={11} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  autoComplete="off"
                  value={priceValue}
                  readOnly
                />
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Specijalizacija:</span>
              </Col>
              <Col xs={12} sm={11} className={styles.inputAntdRow}>
                <Input
                  className={styles.invoiceCustomInput}
                  autoComplete="off"
                  value={specializationValue}
                  readOnly
                />
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Ljekar:</span>
              </Col>

              <Col xs={12} sm={11} className={styles.invoiceCustomInput}>
                <Form.Item
                  className={styles.formItem}
                  name="doctor"
                  rules={[
                    {
                      required: true,
                      message: "Izaberite ljekara!",
                    },
                  ]}
                >
                  {role != "D" ? (
                    <Select
                      //disabled={role=='D'}
                      showSearch
                      //style={{ width: 200 }}
                      optionFilterProp="data-searchvalue"
                      placeholder="Izaberite doktora"
                      notFoundContent={"Nema rezultata"}
                    >
                      {getSelectDoctorOptions(doctors || [])}
                    </Select>
                  ) : (
                    <Input
                      disabled={true}
                      defaultValue={
                        userInfo.doctor ? userInfo.doctor.first_name : ""
                      }
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Termin pregleda: </span>
              </Col>

              <Col xs={12} sm={11} className={styles.inputAntdRow}>
                <Form.Item
                  className={styles.formItem}
                  name="report_date"
                  rules={[
                    {
                      required: true,
                      message: "Unesite datum!",
                    },
                  ]}
                >
                  <DatePicker
                    onChange={getUnavailableDates}
                    className={styles.invoiceCustomInput}
                    //size="large"
                    format="DD/MM/YY"
                    //disabledDate={disabledDate}
                    placeholder="Izaberite termin"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}></Col>
              <Col xs={12} sm={11} className={styles.inputAntdRow}>
                <Form.Item
                  className={styles.formItem}
                  name="report_date_time_range"
                  rules={[
                    {
                      required: true,
                      message: "Izaberite sate",
                    },
                  ]} /* #TODO prvo izbor datuma pa izbor range */
                >
                  <TimePickerRange
                    reportTimeRange={reportTimeRange}
                    setReportTimeRange={setReportTimeRange}
                    disabledDates={disabledDates}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className={styles.formTwoSetFields}>
              <Col xs={10} sm={8}>
                <span>Opis:</span>
              </Col>

              <Col xs={12} sm={11} className={styles.invoiceCustomInput}>
                <Form.Item
                  name="note"
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                  className={styles.formItem}
                >
                  <TextArea className={styles.DisableResize} rows={4} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      {role == "D" ? (
        <>
          <div
            //className={styles.medicalReportFormBoxes}
            style={{ margin: "40px 0" }}
          >
            <Row gutter={[40, 2]}>
              <Col span={24}>
                <h2>Nalaz</h2>
                <TextArea
                  maxLength={6500}
                  autoSize={{ minRows: 9, maxRows: 20 }}
                  placeholder="Unesite tekst"
                  rows={6}
                  value={medical_record}
                  onChange={(e) => {
                    setMedicalRecord(e.target.value);
                  }}
                />
              </Col>
            </Row>
          </div>

          <div
            //className={styles.medicalReportFormBoxes}
            style={{ margin: "40px 0" }}
          >
            <Row gutter={[40, 2]}>
              <Col span={24}>
                <h2>Anamneza</h2>
                <TextArea
                  maxLength={1500}
                  placeholder="Unesite tekst"
                  autoSize={{ minRows: 3, maxRows: 15 }}
                  value={anamnesis}
                  onChange={(e) => {
                    setAnamnesis(e.target.value);
                  }}
                />
              </Col>
            </Row>
          </div>

          <div
            //className={styles.medicalReportFormBoxes}
            style={{ margin: "40px 0" }}
          >
            <Row gutter={[60, 2]}>
              <Col span={24}>
                <h2>Dijagnoza</h2>

                <AutoComplete
                  maxLength={1500}
                  name="diagnosis"
                  autocompleteValue={diagnosis}
                  changeValue={onChangeDiagnosisValue}
                  //autocompleteName="customer_name"
                  //options={diagnoses}
                  //updateCustomerFields={autoCompleteUpdate}
                  //initialValue={diagnosis}
                  field="name"
                  placeHolder="Unesite dijagnozu"
                ></AutoComplete>
              </Col>
            </Row>
          </div>

          <div
            //className={styles.medicalReportFormBoxes}
            style={{ margin: "40px 0" }}
          >
            <Row gutter={[40, 2]}>
              <Col span={24}>
                <h2>Terapija</h2>
                <TextArea
                  maxLength={1500}
                  placeholder="Unesite tekst"
                  autoSize={{ minRows: 3, maxRows: 15 }}
                  value={therapy}
                  onChange={(e) => {
                    setTherapy(e.target.value);
                  }}
                />
              </Col>
            </Row>
          </div>

          <div
            //className={styles.medicalReportFormBoxes}
            style={{ margin: "40px 0" }}
          >
            <Row gutter={[40, 2]}>
              <Col span={24}>
                <h2>Ultrazvuk</h2>

                {isUZAccessible ? (
                  <Button
                    disabled={selectedImages.length > 1 || buttonUZLoading}
                    style={{ marginBottom: "10px" }}
                    onClick={fetchImageFromUZ}
										loading={buttonUZLoading}
                  >
                    Povuci sliku sa Ultra Zvuka
                  </Button>
                ) : null}

                <Upload
                  fileList={selectedImages}
                  maxCount={2}
                  listType="picture"
                  customRequest={dummyRequest}
                  onRemove={handleImageRemove}
                  onChange={handleImageChange}
                  multiple
                >
                  {selectedImages.length < 2 ? (
                    <Button disabled={selectedImages.length > 1}>
                      Dodaj sliku
                    </Button>
                  ) : null}
                </Upload>
              </Col>
            </Row>
          </div>

          <Row gutter={[40, 2]} justify="center" style={{ margin: "20px 0" }}>
            {enableEdit ? (
              <>
                <Popover content="Odustani od dodavanja" trigger="hover">
                  <Button
                    className={styles.cancelButton}
                    onClick={() => {
                      confirmCancelMedicalReportForm();
                    }}
                  >
                    Odustani
                  </Button>
                </Popover>

                <Popover content="Dodaj izvještaj" trigger="hover">
                  <Button
                    type="primary"
                    className={styles.addButton}
                    onClick={saveMedicalReport}
                    loading={buttonLoading}
                  >
                    Sačuvaj
                  </Button>
                </Popover>
              </>
            ) : (
              <>
                <Popover content="Odustani od izmjene" trigger="hover">
                  <Button
                    type="default"
                    onClick={() => {
                      confirmCancelMedicalReportForm();
                    }}
                  >
                    Odustani
                  </Button>
                </Popover>

                <Popover content="Sačuvaj izmjene" trigger="hover">
                  <Button
                    type="primary"
                    className={styles.addButton}
                    loading={buttonLoading}
                    onClick={form.submit}
                  >
                    Sačuvaj
                  </Button>
                </Popover>
              </>
            )}
          </Row>
        </>
      ) : role == "N" ? (
        <>
          <Row
            gutter={[40, 2]}
            justify="center"
            style={{ marginTop: "100px !important", margin: "100px 0" }}
          >
            {enableEdit ? (
              <>
                <Popover content="Odustani od dodavanja" trigger="hover">
                  <Button
                    className={styles.cancelButton}
                    onClick={() => {
                      confirmCancelMedicalReportForm();
                    }}
                  >
                    Odustani
                  </Button>
                </Popover>

                <Popover content="Potvrdi pregled" trigger="hover">
                  <Button
                    type="primary"
                    className={styles.addButton}
                    onClick={saveMedicalReport}
                    loading={buttonLoading}
                  >
                    Sačuvaj
                  </Button>
                </Popover>
              </>
            ) : (
              <>
                <Popover content="Odustani od izmjene" trigger="hover">
                  <Button
                    type="default"
                    onClick={() => {
                      confirmCancelMedicalReportForm();
                    }}
                  >
                    Odustani
                  </Button>
                </Popover>

                <Popover content="Sačuvaj izmjene" trigger="hover">
                  <Button
                    type="primary"
                    className={styles.addButton}
                    loading={buttonLoading}
                    onClick={form.submit}
                  >
                    Sačuvaj
                  </Button>
                </Popover>
              </>
            )}
          </Row>
        </>
      ) : null}
      <AddOrEditPatient
        visibleModal={visiblePatientModal}
        onCloseModal={() => setVisiblePatientModal(false)}
        onAddPatient={async () => {
          setVisiblePatientModal(false);
          let patient = await getPatients();
          form.setFieldsValue({ patient: patient.id });
          setPatientDetails(patient);
        }}
        //onAdd={getPatients}
      />
      <AddOrEditReportType
        visibleModal={visibleReportTypeModal}
        onCloseModal={() => setVisibleReportTypeModal(false)}
        onAddReportType={async () => {
          setVisibleReportTypeModal(false);
          let report_type = await getReportTypes();
          form.setFieldsValue({ report_type: report_type.id });
          setReportTypeDetails(report_type);
        }}
        //onAdd={getReportTypes}
      />
    </>
  );
};
